import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=066a4f1c"
import script from "./CompaniesList.vue?vue&type=script&lang=js"
export * from "./CompaniesList.vue?vue&type=script&lang=js"
import style0 from "./CompaniesList.vue?vue&type=style&index=0&id=066a4f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports